import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

export function useClearFilters(exclude?: string[]) {
  const [searchParams, setSearchParams] = useSearchParams();

  return useCallback(() => {
    [...searchParams.keys()]
      .filter((key) => !exclude?.includes(key))
      .forEach((key) => searchParams.delete(key));
    setSearchParams(searchParams);
  }, [exclude, searchParams, setSearchParams]);
}
